<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted() {
    window.fbAsyncInit = function () {
      FB.init({
        appId: '838504286265302',
        cookie: true,
        xfbml: true,
        version: 'v2.9'
      });

      FB.AppEvents.logPageView();
    };
  },
}
</script>
